import { USERS_API_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';

/**
 * Optimistic update for dashboard field visibility (buffered)
 * This action will update the store immediately and queue the API call
 * @param {string} userId
 * @param {import('modules/users/types/dashboardPreferences').DashboardType} dashboardType
 * @param {import('modules/users/types/dashboardPreferences').FieldEnum[]} hiddenFields
 * @returns {import('modules/users/types/dashboardPreferences').OptimisticUpdateDashboardFieldAction}
 */
export const optimisticUpdateDashboardField = (userId, dashboardType, hiddenFields) => ({
  type: types.OPTIMISTIC_UPDATE_DASHBOARD_FIELD,
  payload: {
    userId,
    dashboardType,
    hiddenFields,
  },
});

/**
 * Rollback dashboard fields to previous state after API failure
 * @param {string} userId
 * @param {import('modules/users/types/dashboardPreferences').DashboardType} dashboardType
 * @param {import('modules/users/types/dashboardPreferences').FieldEnum[]} hiddenFields
 * @returns {import('modules/users/types/dashboardPreferences').RollbackDashboardFieldsAction}
 */
export const rollbackDashboardFields = (userId, dashboardType, hiddenFields) => ({
  type: types.ROLLBACK_DASHBOARD_FIELDS,
  payload: {
    userId,
    dashboardType,
    hiddenFields,
  },
});

/**
 * @param {string} userId
 * @param {import('modules/users/types/dashboardPreferences').DashboardType} dashboardType
 * @param {import('modules/users/types/dashboardPreferences').FieldEnum[]} hiddenFields
 * @param {Object} [meta={}]
 * @returns {import('modules/users/types/dashboardPreferences').PatchDashboardSettingsAction}
 */
export const patchDashboardSettings = (userId, dashboardType, hiddenFields, meta = {}) => ({
  type: types.PATCH_DASHBOARD_SETTINGS_REQUEST,
  payload: {
    request: {
      method: 'PATCH',
      url: `${USERS_API_URL}/${userId}/displaySettings/dashboard/${dashboardType}`,
      data: { hiddenFields },
    },
    userId,
    dashboardType,
    hiddenFields,
  },
  meta,
});
